import { Expression } from './Expression.js';
import { OclExecutionContext } from '../OclExecutionContext.js';

export class OperationDefExpression extends Expression {
  //@ts-ignore
  constructor(
    public name: string,
    public paramNames: Array<string>,
    public inContextDef: Expression
  ) {
    super();
  }

  // getKey(): string {
  //   return this.key;
  // }
  //
  // getValue(): Expression {
  //   return this.value;
  // }

  evaluate(visitor: OclExecutionContext, localVariables?: any): any {
    const object = visitor.getObjectToEvaluate();
    if (object) {
      object[this.name] = (...params: any[]) => {
        let operationParams: any = {};
        if (this.paramNames) {
          this.paramNames.forEach((v, i) => operationParams[v] = params[i]);
        }

        const locals = { ...localVariables, ...operationParams };
        return this.inContextDef.evaluate(visitor, locals);
      } //this.inContextDef;
    } else {
      //TODO: Investigate
      console.warn('Cannot def operation');
    }
  }
}
